export function infoBoxModule(item) {
  
  let infoBg = "";
  //write a case statement based on item.content.properties.title
  switch (item.properties.background.label) {
    case "green-60":
      infoBg = "bg-green-60";
      break;
    case "blue-20":
      infoBg = "bg-blue-20";
      break;
    case "pink-70":
      infoBg = "bg-pink-70";
      break 
    case "orange-40":
      infoBg = "bg-orange-40";
      break;
    default:
      infoBg = "bg-pink-70";
  }
    

  const infoBoxModule = `
    <div class="relative col-span-12 mb-7" data-component="info-box">
      <div class="absolute -top-5 left-6 w-10 h-10 border border-blue rounded-full flex items-center justify-center ${infoBg}">
        <svg class="h-5 w-2">
          <use xlink:href="/spritemap.svg#sprite-info"></use>
        </svg>
      </div>
      <div class="border border-blue bg-white py-10 px-6 prose">
        ${item.properties.title != "" ? `<p class="text-headline3 mb-4 font-bold">${item.properties.title}</p>` : ""}
        ${item.properties.content != "" ? `${item.properties.content.markup}` : ""}
      </div>
    </div>
  `;
  return infoBoxModule;
}